import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import {
    StyledScoringBoard,
    StyledScoringPriorityColumn,
} from "app/pages/sales-intelligence/modules/lead-scoring-agent/components/scoring-board/styles";

import { StyledScoringSettingsPageLoaderHeader } from "./styles";

export const ScoringSettingsPageLoader = () => (
    <Stack
        gap="24px"
        width="100%"
        data-automation="score-settings-page-loader"
    >
        <StyledScoringSettingsPageLoaderHeader>
            <Stack gap="8px">
                <PixelPlaceholderLoader
                    width={280}
                    height={24}
                />
                <PixelPlaceholderLoader
                    width={420}
                    height={14}
                />
            </Stack>
            <PixelPlaceholderLoader
                width={140}
                height={32}
            />
        </StyledScoringSettingsPageLoaderHeader>

        <StyledScoringBoard>
            {Array.from({ length: 3 }, (_, index) => (
                <StyledScoringPriorityColumn
                    key={index}
                    gap="12px"
                >
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <PixelPlaceholderLoader
                            width={72}
                            height={16}
                        />
                        <PixelPlaceholderLoader
                            width={88}
                            height={28}
                        />
                    </Flex>
                    <PixelPlaceholderLoader
                        width="100%"
                        height={120}
                    />
                </StyledScoringPriorityColumn>
            ))}
        </StyledScoringBoard>
    </Stack>
);
